var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5576 13.7033C14.5576 14.4561 13.9458 15.0909 13.1931 15.0909H2.27447C1.52172 15.0909 0.909958 14.4561 0.909958 13.7033V2.78469C0.909958 2.03195 1.52172 1.4424 2.27447 1.4424H8.64332V0.533295H2.27447C1.02018 0.533295 0 1.53126 0 2.78555V13.7033C0 14.9576 1.02018 16 2.27447 16H13.1922C14.4465 16 15.4667 14.9568 15.4667 13.7033V7.35669H14.5568V13.7033H14.5576Z",
    fill: "#594AD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8076 2.48559L14.4816 2.81217L13.1758 1.5041L13.5018 1.17752C13.8504 0.828358 14.4591 0.828358 14.8076 1.17752C14.9819 1.3521 15.0782 1.58401 15.0782 1.83155C15.0782 2.0791 14.9819 2.311 14.8076 2.48559ZM8.70302 8.59949L6.96191 9.03551L7.39719 7.29143L12.5208 2.15906L13.8266 3.46712L8.70302 8.59949ZM15.4595 0.524398C14.7624 -0.174799 13.5458 -0.174799 12.8478 0.524398L6.65427 6.72858C6.59531 6.78764 6.55282 6.86234 6.53288 6.94312L5.88083 9.55837C5.84181 9.71558 5.88777 9.88235 6.00222 9.99787C6.0898 10.0856 6.20772 10.1334 6.32825 10.1334C6.36553 10.1334 6.40282 10.129 6.4401 10.1195L9.05175 9.46544C9.13326 9.44546 9.20696 9.4029 9.26592 9.34384L15.4595 3.13966C15.8081 2.79049 16.0006 2.32581 16.0006 1.83159C16.0006 1.33738 15.8089 0.873562 15.4595 0.524398Z",
    fill: "#594AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconAnnouncement);
export default __webpack_public_path__ + "static/media/editIconAnnouncement.00f901ff840bd54da5fcacd5ea00627c.svg";
export { ForwardRef as ReactComponent };